// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"8e1d64f0","611":"8e1d64f0"}[chunkId] + ".chunk.css";
};